import { ImdgCodeClassBM } from "src/types/BusinessModel/Stowage/Product/ImdgCodeClassBM";
import { ImdgCodeClass } from "src/types/ViewModel/Stowage/Product/ImdgCodeClass";

export const createImdgCodeClass = (imdgClassCodeBM: ImdgCodeClassBM): ImdgCodeClass => {
    return {
        id: imdgClassCodeBM.id,
        classification: imdgClassCodeBM.classification,
        description: imdgClassCodeBM?.description,
    };
};
